import { cx } from "@emotion/css";
import {
	isLessonDisabled,
	isLessonResolved,
} from "src/components/Course/lessons/Lesson/RepetitionLesson";
import DefaultActions from "src/components/NewComponents/Views/Actions/DefaultActions";
import DefaultDetails, {
	DefaultScore,
} from "src/components/NewComponents/Views/Details/DefaultDetails";
import DefaultScoreView from "src/components/NewComponents/Views/ScoreViews/DefaultScoreView";
import { useGetLesson } from "src/hooks/useCourses";

interface BreakLessonProps {
	lesson: any;
	className?: string;
}

export const BreakLesson = ({ lesson, className }: BreakLessonProps) => {
	const { mutateAsync: getLesson, isPending: isLoading } = useGetLesson();

	const onPrimary = async (e: React.MouseEvent) => {
		e.stopPropagation();
		e.preventDefault();
		await (getLesson as any)({
			courseId: lesson.courseId,
			lessonId: lesson.id,
		});
	};

	return (
		<DefaultScoreView
			className={cx(className, {
				"disabled-lesson": isLessonDisabled(lesson),
			})}
			Details={
				<DefaultDetails
					Progress={() => null}
					className="mr-32"
					title={lesson.name}
					Score={() => (
						<div className="flex items-center justify-start gap-8">
							<DefaultScore
								className="success-box"
								title={
									<div className="flex gap-4">
										<span>Wolne</span>
									</div>
								}
							/>
						</div>
					)}
				/>
			}
			Actions={
				isLessonResolved(lesson) ? null : (
					<DefaultActions
						isLoading={isLoading}
						onPrimary={onPrimary}
						primaryText="Kontynuuj"
						menuButtonTestId={`break-lesson-menu-${lesson.id}`}
					/>
				)
			}
		/>
	);
};
